<template>
  <div class="searchDoc">
    <div class="searchDoc__wrapper">
      <search @selected="selected"> </search>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'adx-search-doc',
  components: {
    Search
  },
  methods: {
    selected(item){
      
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>